import PropTypes from 'prop-types';
import { Clock } from 'lucide-react'

export default function ActivityItem({ initials, title, description, timestamp }) {
  return (
    <div className="flex items-start gap-3 py-3 border-b border-gray-100 last:border-b-0">
      <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center text-xs font-semibold text-primary shrink-0">
        {initials}
      </div>
      <div className="min-w-0">
        <p className="text-sm text-foreground"><span className="font-medium">{title}</span> {description}</p>
        <p className="text-xs text-muted-foreground flex items-center gap-1"><Clock className="h-3 w-3" />{timestamp}</p>
      </div>
    </div>
  );
}

ActivityItem.propTypes = {
  initials: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  timestamp: PropTypes.string.isRequired,
};

ActivityItem.defaultProps = {
  description: '',
};
